var modules_6b210db9 = {"container":"_wqe7f9","item-base":"_1sljqw1","item-group":"_1hromdf","item":"_6brmcs","active":"_17nuj38","disabled":"_143i20m","icon":"_ajpz4j","control":"_xu069i","control-indent":"_18wwbv5","description":"_rc6xhc","text":"_10xg8oz","label":"_zn61e3"};
import "../../../assets/CW9_HO_R.css";

export { modules_6b210db9 as default };
//# sourceMappingURL=Menu.module.less.js.map
